import React, { useState } from 'react';
import { onGetErrorMessage, onGetFileExtension, onGetImageURL2Blob } from '../../../../shared/utility';
import PictureModal from '../../../../components/Overlays/PictureModal';
import { request_delete_image_file, request_upload_promotionalbanner_image } from '../requests';
import { translations as translations_esp } from '../../../../texts/esp/modals-translations';

const ChangeImageModal = (props) => {

    const {id, open, onClose, type, onUpdateCompleted} = props
    const content = translations_esp.change_image_modal
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const onSubmit = async(file) => {
        if(!file){
            setError(content.error_msg)
            return
        }
        setError(null)
        setDisabled(true)
        try {
            setLoading(true)
            const _file = await onGetImageURL2Blob(file)
            //console.log(_file)
            let data
            if(type === 'web'){data = {document:"banner_web", type:onGetFileExtension(_file.name)}}
            else{data = {document:"banner_mobile", type:onGetFileExtension(_file.name)}}
            await request_upload_promotionalbanner_image(id, _file, data)
            onClose()
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
        }
        setLoading(false)
        setDisabled(false)
    }

    const onDelete = async() => {
        try {
            setDisabled(true)
            setError(null)
            setLoading(true)
            let data
            if(type === 'web'){data = '?document=banner_web'}
            else{data = '?document=banner_mobile'}
            console.log(data)
            await request_delete_image_file(id, data)
            onUpdateCompleted()
            onClose()
        } catch (error) {
            console.log(error.response)
            setError(onGetErrorMessage(error))
        }
        setLoading(false)
        setDisabled(false)
    }

    return ( 
        <PictureModal open={open} onClose={onClose} loading={loading} error={error} aspect_ratio={16/9} disabled={disabled}
            title={content.title} btnLabel={content.button} onChangeFile={onSubmit} onDeleteFile={onDelete}/>
     );
}
 
export default ChangeImageModal;